import { render, staticRenderFns } from "./TaxpayerTypesSelect.vue?vue&type=template&id=b8aba1e4&"
import script from "./TaxpayerTypesSelect.vue?vue&type=script&lang=ts&"
export * from "./TaxpayerTypesSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports